import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController, AlertController, Platform } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Storage } from '@ionic/storage';

import { PaymentMethod } from '../../models/payment-method';
import { PaymentMethodHandler } from '../../providers/payment-method-handler';

import { CardIO } from '@ionic-native/card-io';

declare var Card: any;
declare var Payment: any;
declare var $: any;

@Component({
  selector: 'page-payment-method-management',
  templateUrl: 'payment-method-management.html',
})
export class PaymentMethodManagementPage {
	paymentMethod: PaymentMethod;
	hasErrors: boolean = false;
	errors: any;
	card: any;
	cardClass: any = "credit-card";
	formClass: any = "credit-card-form";
	initialized = false;
	closeOnAdd: any;
	caller: any;

	private paymentMethodForm : FormGroup;

	constructor(
		private elRef: ElementRef,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public alertCtrl: AlertController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public paymentMethodHandler: PaymentMethodHandler,
		public storage: Storage,
		public platform: Platform,
		private cardIO: CardIO,
		public actionSheetCtrl: ActionSheetController
		) {
		this.paymentMethod = navParams.get('method');
		this.closeOnAdd = navParams.get('closeOnAdd');
		this.caller = navParams.get('caller');

	    this.paymentMethodForm = this.formBuilder.group({
	    	"id": [0],
			"number": ['', Validators.required],
			"expiry": ['', Validators.required],
			"cvc": ['', Validators.required],
			"cardType": ['Visa'],
			"isDefault": [false],
	    });

    	this.paymentMethodForm.patchValue(
    		this.paymentMethod
    	)   
	}

	ngOnInit() {
		if(this.paymentMethod.number){
			let index = this.paymentMethodHandler.getCardIndex(this.paymentMethod.number);

			this.cardClass = this.cardClass + "-management-" + index;		
			this.formClass = this.formClass + "-management-" + index;				
		}
	}  		

	ionViewDidLoad() {
		console.log('ionViewDidLoad PaymentMethodManagementPage');
	}

	ngAfterViewInit() {
		this.initCard()  
	}  

	initCard() {
		this.card = new Card({
		    form: "." + this.formClass,
		    container: "." + this.cardClass,

		    placeholders: {
				number: this.paymentMethod.number,
				name: this.paymentMethod.name,
				expiry: this.paymentMethod.expiry,
				cvc: this.paymentMethod.cvc
			},

		    formSelectors: {
		      numberInput: 'input[formcontrolname="number"]',
		      expiryInput: 'input[formcontrolname="expiry"]',
		      cvcInput: 'input[formcontrolname="cvc"]',
		      nameInput: 'input[formcontrolname="name"]'
		    },			
		});

		if(this.paymentMethod.number){
			this.paymentMethodHandler	
				.setCardType(this.elRef.nativeElement, this.paymentMethod.number);			
		}	

		this.initialized = true;
	}

	tryDelete(){
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Delete this card?',
	     buttons: [
	       {
	         text: 'Yes',
	         handler: () => {
	           	console.log('Archive clicked');

	           	this.deleteMethod()

	           	let navTransition = actionSheet.dismiss();


		        navTransition.then(() => {
		          this.navCtrl.pop();
		        });

	           	return false;
	         }
	       },
	       {
	         text: 'No',
	         handler: () => {
	           actionSheet.dismiss();

	           return false;
	         }
	       }
	     ]
	   });

	   actionSheet.present();		
	}

	deleteMethod(){
		this.paymentMethodHandler.removeMethod(
			this.paymentMethodForm.value.id
		);					
	}

	save(){
		this.hasErrors = false;
		this.errors = "";
		var id = this.paymentMethodForm.value.id;

		this.setNumberToForm();

		if(this.paymentMethodHandler.methodShouldBeDefault(id)){
			this.paymentMethodForm.value.isDefault = true;
		}

		if(this.paymentMethodForm.value.isDefault){
			this.paymentMethodHandler.removeDefaultFromOthers(id);
		}

		if(!this.paymentMethodHandler.methodIsUnique(this.paymentMethodForm.value)){
			this.errors = "Card already exists"
		}		

		if(this.errors!=""){
			this.hasErrors = true;

			let alert = this.alertCtrl.create({
              title: 'Error',
              message: this.errors,
              buttons: ['Ok']
            });

            alert.present();

			return;
		}

		if(id>0){
			this.paymentMethodHandler.updatePaymentMethod(
				this.paymentMethodForm.value
			);				
		}else{
			id = this.paymentMethodHandler.paymentMethods.length + 1;

			this.paymentMethodForm.value.id = id;

			this.paymentMethodHandler.addPaymentMethod(
				this.paymentMethodForm.value
			);			
		}

		this.navCtrl.pop();

		if(this.closeOnAdd){
			this.caller.navCtrl.pop();
		}
	}

	setNumberToForm(){
		var el = $(this.elRef.nativeElement)
		.find(".card-number input")
		.get(0);

		var number = $(el).val();

		this.paymentMethodForm.patchValue({
			"number": number,		    		
		})							
	}

	formatNumber(){
		var el = $(this.elRef.nativeElement)
		.find(".card-number input")
		.get(0);

		var event = new Event('paste');

		el.dispatchEvent(event)

		this.paymentMethodHandler	
		.setCardType(this.elRef.nativeElement, this.paymentMethodForm.value.number);		
	}

	scan(){	
		this.platform.ready().then((readySource) => {
			if(readySource=="dom") return

			this.cardIO.canScan()
			  .then(
			    (res: boolean) => {
			      if(res){
			        let options = {
			          requireExpiry: true,
			          requireCCV: false,
			          requirePostalCode: false
			        };

					this.cardIO.scan(options).then((data) => {
						//this.setCardData(data);
						console.log(data)

				    	this.paymentMethodForm.patchValue({
							"number": data.cardNumber,
							"expiry": data.expiryMonth + "/" + data.expiryYear,
							"name": data.cardholderName,
							"cvc": data.cvv,
							"cardType": data.cardType,				    		
				    	})

						this.formatNumber();
					}, err => {
						console.log(err);
						// An error occurred
					});
			      }
			    }
			  );	
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/payment-method-management/payment-method-management.ts